import React, { FC } from 'react';

const IconContacto: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17" {...props}>
      <path
        fillRule="evenodd"
        d="M20,10.156963 C20,12.0073172 19.2235616,13.7978037 17.7167123,15.0273081 C17.700274,15.0411663 19.0065753,18.3333333 19.0065753,18.3333333 C19.0065753,18.3333333 13.7326027,17.2618131 13.7183562,17.266802 C12.5791781,17.6515072 11.3139726,17.8139259 10,17.8139259 C4.47726027,17.8139259 0,14.385948 0,10.156963 C0,5.92853225 4.47726027,2.5 10,2.5 C15.5227397,2.5 20,5.92853225 20,10.156963"
        transform="translate(0 -2)"
      />
    </svg>
  );
};

export default IconContacto;
